import {
    TimeSheetTypes,
} from '../ActionTypes/TimeSheetTypes';

class TimeSheetActions {

    static getTimeSheetCleaner = payload => {
        return {
            type: TimeSheetTypes.GET_TIME_SHEET_CLEANER,
            payload: payload,
        };
    };

    static clearTimeSheetCleaner = () => {
        return {
            type: TimeSheetTypes.CLEAR_TIME_SHEET_CLEANER,
        };
    };

    static getTimeSheet = payload => {
        return {
            type: TimeSheetTypes.GET_TIME_SHEET,
            payload: payload,
        };
    };

    static clearTimeSheet = () => {
        return {
            type: TimeSheetTypes.CLEAR_TIME_SHEET,
        };
    };
}

export default TimeSheetActions;
